import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const styles = (theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
    },
    name: {
        marginLeft: '10px'
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
});  
  
const UserAvatar = ({ classes, image, name }) => {
    return (<div className={classes.root}> 
        <Avatar alt="Remy Sharp" src={image} className={classes.small}/>
        <span className={classes.name}> {name} </span>
    </div>);
}

export default withStyles(styles)(UserAvatar);